import * as tslib_1 from "tslib";
import { PropertyNames } from "h3-forms";
// @ts-ignore
import isEqual from 'lodash/isEqual';
import moment from "moment";
import { debounceTime } from "rxjs/operators";
import { Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { formApi, listApi } from "../../../../api";
import dateFormat from "../../../../common/src/utils/date";
import { DataItemType, FormControlType, OperatorService } from "../.././../schema";
import { ControlHelper } from "./control-helper";
// 二开开始
import Bus from "@cloudpivot/form/utils/bus";
// 二开结束
export class BaseControl extends Vue {
    constructor() {
        super(...arguments);
        this.styleObj = {};
        this.valueChangeSubscription = null;
        this.onChangeFn = null;
    }
    get id() {
        if (this.control.parentKey) {
            return `${this.control.parentKey}-${this.control.key}`;
        }
        return this.control.key;
    }
    get ctrl() {
        if (!this.control.controller) {
            if (!this.control.parentKey) {
                const _ctrl = this.findController(this.control.key);
                this.$set(this.control, "controller", _ctrl);
                // this.$set(this.control, "edit", _ctrl.readonly === false);
                // this.control.edit = _ctrl.readonly === false;
            }
        }
        if (this.control.parentKey) {
            // @ts-ignore
            this.control.controller.parentKey = this.control.parentKey;
        }
        return this.control.controller;
    }
    get readonly() {
        // return this.control.edit === false;
        if (this.ctrl) {
            return !!this.ctrl.readonly;
        }
        return false;
    }
    onCtrlItemsChange(value) {
        if (value) {
            this.controlOpts.options = Array.isArray(value) ? value.join(";") : value;
        }
    }
    get controlOpts() {
        return this.control.options;
    }
    get style() {
        return this.controlOpts.style || null;
    }
    get label() {
        return ControlHelper.getControlLabel(this.control, this.$i18n.locale);
    }
    get locale() {
        return this.$i18n.locale || "zh";
    }
    get placeholder() {
        // var aa = this.locale;
        if (!((this.control.type === FormControlType.Text && this.controlOpts.placeholder === 'Please enter') ||
            (this.control.type === FormControlType.Textarea && this.controlOpts.placeholder === 'Please enter') ||
            (this.control.type === FormControlType.Number && this.controlOpts.placeholder === 'Please enter') ||
            (this.control.type === FormControlType.NumberRange && this.controlOpts.placeholder === 'Please enter'))) {
            if (this.controlOpts.placeholder) {
                return this.controlOpts.placeholder;
            }
        }
        switch (this.control.type) {
            case FormControlType.Text:
            case FormControlType.Textarea:
            case FormControlType.Number:
            case FormControlType.NumberRange:
                return this.$t("cloudpivot.form.renderer.pleaseInput");
            case FormControlType.Date:
            case FormControlType.StaffSelector:
            case FormControlType.StaffMultiSelector:
            case FormControlType.DepartmentSelector:
            case FormControlType.DepartmentMultiSelector:
            case FormControlType.StaffDeptMixed:
            case FormControlType.Dropdown:
            case FormControlType.DropdownMulti:
            case FormControlType.Checkbox:
            case FormControlType.Radio:
            case FormControlType.Address:
            case FormControlType.Location:
            case FormControlType.RelevanceForm:
            case FormControlType.RelevanceFormEx:
                return this.$t("cloudpivot.form.renderer.pleaseSelect");
        }
        return "";
    }
    get readonlyFormula() {
        //获取是否只读布尔类型
        if (this.controlOpts.readonlyFormula) {
            return this.controlOpts.readonlyFormula;
        }
        else {
            //获取只读规则校验的结果
            if (this.ctrl) {
                return !!this.ctrl.disabled;
            }
        }
    }
    // 是否为外部用户
    get isExternal() {
        return !!window.isExternal;
    }
    getIsNew() {
        let isNew = window.h3form ? !!window.h3form.isNew : true;
        return isNew;
    }
    get InEdit() {
        return window.h3form ? !!window.h3form.inEdit : false;
    }
    getPopupContainer() {
        // if (this.getScrollEl) {
        //   const scrollEl = this.getScrollEl();
        //   if (scrollEl) {
        //     return scrollEl;
        //   }
        // }
        // return triggerNode.parentNode;
        return (triggerNode) => {
            if (this.getScrollEl) {
                const scrollEl = this.getScrollEl();
                if (scrollEl) {
                    return scrollEl;
                }
            }
            return document.body;
        };
    }
    getThisProxy() {
        return this.getController().children;
    }
    getControllerGroup() {
        return this.getController();
    }
    recordDelFile(delFile) {
        // if(this.$root.$store.state.delFile) {
        //   // @ts-ignore
        //   this.$root.$store.state.delFile.push({ name: delFile.response ? delFile.response.data.name : delFile.name, refId: delFile.response ? delFile.response.data.refId : delFile.refId })
        // } else {
        //   // @ts-ignore
        //   this.$root.$store.state.delFile = [{ name: delFile.response ? delFile.response.data.name : delFile.name, refId: delFile.response ? delFile.response.data.refId : delFile.refId }]
        // }
        //  产品修复外链表单附件上传后不能删除问题
        if (this.$root.$store) {
            if (this.$root.$store.state.delFile) {
                // @ts-ignore
                this.$root.$store.state.delFile.push({ name: delFile.response ? delFile.response.data.name : delFile.name, refId: delFile.response ? delFile.response.data.refId : delFile.refId });
            }
            else {
                // @ts-ignore
                this.$root.$store.state.delFile = [{ name: delFile.response ? delFile.response.data.name : delFile.name, refId: delFile.response ? delFile.response.data.refId : delFile.refId }];
            }
        }
    }
    // 二开开始
    setValue(value) {
        if (this.ctrl)
            this.ctrl.value = value;
        if (this.ctrl.id === "bmwGroupGuidelines" && value[0] === 'Yes') {
            Bus.$emit('bmwGroupGuidelines', true);
        }
        else if (this.ctrl.id === "chinaNscWitLogon" && value[0] === 'Yes') {
            Bus.$emit('chinaNscWitLogon', true);
        }
    }
    mySetValue(value, str) {
        if (this.ctrl.id === "bmwGroupGuidelines" && str === '1') {
            this.ctrl.value = value;
        }
        else if (this.ctrl.id === "chinaNscWitLogon" && str === '2') {
            this.ctrl.value = value;
        }
    }
    // 二开结束
    onControlChange(c, oldControl) {
        // 防止 this.$set(this.control, 'controller', _ctrl) 时再次触发change
        if (c === oldControl) {
            return;
        }
        this.$set(this.ctrl, "items", "");
        if (this.setControl) {
            this.setControl();
        }
        if (this.style) {
            this.style
                .trim()
                .split(";")
                .forEach((s) => {
                let [key, value] = s.trim().split(":");
                this.styleObj[key] = value;
            });
        }
        else {
            this.styleObj = {};
        }
        const that = this;
        function timeOutSubscribe() {
            // @ts-ignore
            if (that.ctrl.setReadonlyOver) {
                that.subscribeValueChange();
                that.unRefSubscription(oldControl);
                that.unRefSubscriptionTimer(oldControl);
            }
            else {
                setTimeout(() => {
                    timeOutSubscribe();
                }, 100);
            }
        }
        if (that.ctrl.inSheet) {
            this.subscribeValueChange();
            this.unRefSubscription(oldControl);
            this.unRefSubscriptionTimer(oldControl);
        }
        else {
            timeOutSubscribe();
        }
    }
    subscribeValueChange() {
        let ctrl = this.ctrl;
        if (!ctrl || !ctrl.valueChange) {
            return;
        }
        // if (ctrl && ctrl.options && ctrl.options.hasOwnProperty("dataLinkage") && (this.getIsNew() || (this.getIsWorkflow() && !ctrl.readonly))) {
        //@ts-ignore
        let dataLinkage = ctrl.options.dataLinkage;
        let dataLinkageOption = null;
        if (dataLinkage) {
            if (dataLinkage.isDataLinkOpen) {
                dataLinkageOption = JSON.parse(dataLinkage.options.value);
            }
            else {
                // 兼容老数据
                if (dataLinkage.isDataLinkOpen === false) {
                    dataLinkageOption = JSON.parse(dataLinkage.options.value);
                }
                else {
                    dataLinkageOption = JSON.parse(dataLinkage);
                }
            }
            // 解析dataLinkage, 获取condition、fillProperty、targetModel
            const { condition, fillProperty, targetModel } = dataLinkageOption;
            console.log("------------------dataLinkage-------------", ctrl.id, this.control);
            let fillPropertyArr = fillProperty ? fillProperty.split('=') : [];
            if (fillPropertyArr.length !== 2)
                return;
            let fillSrc = fillPropertyArr[0].substring(1, fillPropertyArr[0].length - 2);
            if (this.control.parentKey) {
                //若联动填充的key值不等于当前数据项的key值，说明数据有误，使用当前替换掉
                fillSrc = fillSrc.split('.')[1] !== this.control.key ? this.control.key : fillSrc.split('.')[1];
                fillSrc = `${this.control.parentKey}.${fillSrc}`;
            }
            else {
                //若联动填充的key值不等于当前数据项的key值，说明数据有误，使用当前替换掉
                fillSrc = fillSrc !== this.control.key ? this.control.key : fillSrc;
            }
            let fillTar = fillPropertyArr[1].substring(2, fillPropertyArr[1].length - 1);
            const condArr = condition ? condition.split('&&') : [];
            let isOnlyMainCondition = condition.indexOf('.') === -1;
            condArr.forEach(x => {
                let arr = x.split('=');
                let { key: currentKey } = this.formatKey(arr[0].substring(1, arr[0].length - 2));
                let controller = null;
                const idx = currentKey.indexOf('.');
                if (idx > -1) {
                    // 子表条件
                    let rowIndex = ctrl.options.rowIndex || 0;
                    const sheetKey = this.control.parentKey || currentKey.substring(0, idx);
                    const controlKey = currentKey.substr(idx + 1);
                    const sheetCtrl = this.findController(sheetKey);
                    if (sheetCtrl) {
                        const row = sheetCtrl.rows[rowIndex];
                        controller = row.findChild(controlKey);
                    }
                }
                else {
                    controller = this.findController(currentKey);
                }
                if (controller && controller.valueChange) {
                    // 有默认值且默认值不为空时触发默认值
                    if (this.getIsNew() && controller.hasValue && controller.value === controller.options.value && controller.value !== null && controller.value !== undefined && controller.value !== "") {
                        setTimeout(() => {
                            let filterArr = [];
                            let extraArr = [];
                            condArr.forEach(item => {
                                let innerArr = item.split('=');
                                let innerCurrentKey = innerArr[0].substring(1, innerArr[0].length - 2);
                                let innerTargetKey = innerArr[1].substring(2, innerArr[1].length - 1);
                                let { key: innerCode } = this.formatKey(innerCurrentKey);
                                let ctrl = null;
                                const idx = innerCode.indexOf('.');
                                if (idx > -1) {
                                    // 子表条件
                                    let rowIndex = controller.options.rowIndex || 0;
                                    const sheetKey = innerCode.substring(0, idx);
                                    const controlKey = innerCode.substr(idx + 1);
                                    const sheetCtrl = this.findController(sheetKey);
                                    if (sheetCtrl) {
                                        const row = sheetCtrl.rows[rowIndex];
                                        ctrl = row.findChild(controlKey);
                                    }
                                }
                                else {
                                    ctrl = this.findController(innerCode);
                                }
                                if (ctrl) {
                                    filterArr.push({
                                        key: innerTargetKey,
                                        val: ctrl.value
                                    });
                                    extraArr.push(innerCurrentKey);
                                }
                            });
                            this.emitOnDataLinkage({
                                filter: filterArr,
                                fillProperty: {
                                    src: fillSrc,
                                    target: fillTar
                                },
                                extraCond: extraArr,
                                targetModel
                            });
                        }, 500);
                    }
                    const optimizationValChange = controller.valueChange.pipe(debounceTime(500));
                    optimizationValChange.subscribe((change) => {
                        console.log("triggered changed ", change, ctrl);
                        if (!ctrl.readonly || this.InEdit) {
                            setTimeout(() => {
                                let filterArr = [];
                                let extraArr = [];
                                condArr.forEach(item => {
                                    localStorage.setItem('isDataLinkageComplete', 'false');
                                    let innerArr = item.split('=');
                                    let innerCurrentKey = innerArr[0].substring(1, innerArr[0].length - 2);
                                    let innerTargetKey = innerArr[1].substring(2, innerArr[1].length - 1);
                                    let { key: innerCode } = this.formatKey(innerCurrentKey);
                                    let ctrl1 = null;
                                    const idx = innerCode.indexOf('.');
                                    if (idx > -1) {
                                        // 子表条件
                                        let rowIndex = controller.options.rowIndex || 0;
                                        // const sheetKey = innerCode.substring(0, idx);
                                        const sheetKey = this.control.parentKey || currentKey.substring(0, idx);
                                        const controlKey = innerCode.substr(idx + 1);
                                        const sheetCtrl = this.findController(sheetKey);
                                        if (sheetCtrl) {
                                            const row = sheetCtrl.rows[rowIndex];
                                            ctrl1 = row.findChild(controlKey);
                                        }
                                    }
                                    else {
                                        ctrl1 = this.findController(innerCode);
                                    }
                                    if (ctrl1) {
                                        filterArr.push({
                                            key: innerTargetKey,
                                            val: ctrl1.value
                                        });
                                        extraArr.push(innerCurrentKey);
                                    }
                                });
                                this.emitOnDataLinkage({
                                    filter: filterArr,
                                    fillProperty: {
                                        src: fillSrc,
                                        target: fillTar
                                    },
                                    extraCond: extraArr,
                                    targetModel
                                });
                            }, 500);
                        }
                    });
                }
            });
        }
        // }
        // if(ctrl.options.hasOwnProperty("computeFormulaNew")){
        //   console.log('---------------------start---------------------------');   
        //   console.log('ctrl',ctrl);
        //   console.log('ctrl.id',ctrl.id);
        //   console.log('ctrl.options',ctrl.options);
        //   //@ts-ignore
        //   console.log('ctrl.options.computeFormulaNew',ctrl.options.computeFormulaNew);
        //   console.log('ctrl.options.hasOwnProperty("computeFormulaNew")',ctrl.options.hasOwnProperty("computeFormulaNew"));
        //   console.log('-----------------------end-------------------------');
        // }
        if (ctrl && ctrl.options && ctrl.options.hasOwnProperty("computeFormulaNew")) {
            //@ts-ignore
            let computeFormulaNew = ctrl.options.computeFormulaNew;
            if (!computeFormulaNew) {
                return;
            }
            let formulaStr = '';
            try {
                let computeObj = JSON.parse(computeFormulaNew);
                if (computeObj) {
                    formulaStr = computeObj.formula;
                }
            }
            catch (err) {
                console.log(err);
            }
            // 解析计算规则表达式，订阅发送
            let relevantDataItems = formulaStr.match(/\{.*?\}/g);
            if (Array.isArray(relevantDataItems)) {
                // formulaStr = formulaStr.toUpperCase()
                // relevantDataItems.forEach((item: string) => {
                //   const reg = "{" + item.substring(1, item.length - 1).toUpperCase() +  "}"
                //   formulaStr = formulaStr.replace(reg, item)
                // })
                relevantDataItems.forEach((formulaItemKey) => {
                    const dataItemKey = formulaItemKey.substring(1, formulaItemKey.length - 1);
                    let controller = null;
                    const idx = dataItemKey.indexOf('.');
                    if (idx > -1) {
                        // 子表条件
                        const sheetKey = dataItemKey.substring(0, idx);
                        const controlKey = dataItemKey.substr(idx + 1);
                        controller = this.findController(sheetKey);
                        if (formulaStr.indexOf('COUNT') > -1 && formulaStr.indexOf('COUNTIF') === -1) {
                            const sheetColumnSubject = controller.getColumnValueChange(controlKey);
                            if (sheetColumnSubject) {
                                sheetColumnSubject.subscribe((change) => {
                                    // 待优化
                                    // 这里根据公式中包含COUNT 判断是COUNT函数 直接订阅rowChange, 其他订阅cellChange
                                    // if (controller && controller.rowChange) {
                                    //   const optimizationRowChange = controller.rowChange.pipe(debounceTime(500));
                                    //   optimizationRowChange.subscribe(() => {
                                    // let sheetController = this.findController(dataItemKey) as any;
                                    // 子表中数据项有值时才进行计算，发起计算请求接口
                                    // if (sheetController.value) {
                                    if (!ctrl.readonly || this.InEdit) {
                                        if (Array.isArray(relevantDataItems)) {
                                            localStorage.setItem('isComputeFormulComplete', 'false');
                                        }
                                        setTimeout(() => {
                                            let bizRuleCalculate = {};
                                            bizRuleCalculate.expression = formulaStr;
                                            let dataParamsMap = {};
                                            if (Array.isArray(relevantDataItems)) {
                                                relevantDataItems.forEach((formulaInnerKey) => {
                                                    let innerCode = formulaInnerKey.substring(1, formulaInnerKey.length - 1);
                                                    let relevantCtrl = null;
                                                    const idx = innerCode.indexOf('.');
                                                    if (idx > -1) {
                                                        // 子表条件
                                                        const sheetKey = innerCode.substring(0, idx);
                                                        const controlKey = innerCode.substr(idx + 1);
                                                        relevantCtrl = this.findController(sheetKey);
                                                        if (relevantCtrl) {
                                                            let data = relevantCtrl.value.map((item) => item[controlKey]) || [];
                                                            data = data.filter(el => !!el);
                                                            dataParamsMap[innerCode] = data.length ? data : [];
                                                        }
                                                    }
                                                    else {
                                                        relevantCtrl = this.findController(innerCode);
                                                        let dataItem = this.getDataItem(innerCode);
                                                        if (relevantCtrl && dataItem) {
                                                            let val = relevantCtrl.value;
                                                            dataParamsMap[innerCode] = this.formatVal(val, dataItem.propertyType);
                                                        }
                                                    }
                                                });
                                                bizRuleCalculate.dataParamsMap = dataParamsMap;
                                                let id = ctrl.id;
                                                // @ts-ignore
                                                let parentKey = ctrl.parentKey ? ctrl.parentKey : '';
                                                let dataItem = this.getDataItem(id, parentKey);
                                                if (dataItem) {
                                                    bizRuleCalculate.schemaCode = dataItem.schemaCode;
                                                    bizRuleCalculate.propertyCode = ctrl.id;
                                                }
                                                formApi.getComputeFormulaVal(bizRuleCalculate)
                                                    .then((res) => {
                                                    if (res && res.errcode === 0) {
                                                        if (dataItem) {
                                                            switch (dataItem.propertyType) {
                                                                case DataItemType.ShortText:
                                                                    ctrl.value = res.data || res.data === false ? String(res.data) : '';
                                                                    break;
                                                                case DataItemType.Number:
                                                                    ctrl.value = res.data ? Number(res.data) : 0;
                                                                    break;
                                                                default:
                                                                    ctrl.value = res.data;
                                                                    break;
                                                            }
                                                        }
                                                    }
                                                    this.setComputeFormulComplete();
                                                })
                                                    .catch((err) => {
                                                    console.log("获取计算值失败", err);
                                                    this.setComputeFormulComplete();
                                                });
                                            }
                                        }, 500);
                                    }
                                });
                            }
                        }
                        else {
                            const sheetColumnSubject = controller.getColumnValueChange(controlKey);
                            if (sheetColumnSubject) {
                                sheetColumnSubject.subscribe((change) => {
                                    if (!ctrl.readonly || this.InEdit) {
                                        // change {index: 3,key: "Date1627012986341",oldValue: [null],parentKey: "Sheet1627012970101",rowIndex: 0,value: [Sat Jul 24 2021 00:00:00 GMT+0800 (中国标准时间)]}
                                        // let sheetController = this.findController(dataItemKey) as any;
                                        if (!ctrl.inSheet) {
                                            if (Array.isArray(relevantDataItems)) {
                                                localStorage.setItem('isComputeFormulComplete', 'false');
                                            }
                                            //主表字段
                                            setTimeout(() => {
                                                let bizRuleCalculate = {};
                                                bizRuleCalculate.expression = formulaStr;
                                                let dataParamsMap = {};
                                                if (Array.isArray(relevantDataItems)) {
                                                    relevantDataItems.forEach((formulaInnerKey) => {
                                                        let innerCode = formulaInnerKey.substring(1, formulaInnerKey.length - 1);
                                                        let relevantCtrl = null;
                                                        const idx = innerCode.indexOf('.');
                                                        if (idx > -1) {
                                                            // 子表条件
                                                            const sheetKey = innerCode.substring(0, idx);
                                                            const innerControlKey = innerCode.substr(idx + 1);
                                                            let dataItem = this.getDataItem(innerControlKey, sheetKey);
                                                            const formulaStrList = ["sum", "avg", "max", "min", "countif"];
                                                            formulaStrList.forEach((formulaItem) => {
                                                                if (formulaStr.indexOf(formulaItem) > -1) {
                                                                    const UpperCaseStr = formulaItem.toUpperCase();
                                                                    formulaStr = formulaStr.replace(formulaItem, UpperCaseStr);
                                                                }
                                                            });
                                                            let isAggregateFunc = formulaStr.indexOf("SUM") > -1 || formulaStr.indexOf("AVG") > -1 || formulaStr.indexOf("MAX") > -1 || formulaStr.indexOf("MIN") > -1 || formulaStr.indexOf("COUNTIF") > -1;
                                                            let tmpVal = null;
                                                            if (controlKey === innerControlKey) {
                                                                tmpVal = isAggregateFunc ? change.value : change.value[change.rowIndex];
                                                            }
                                                            else {
                                                                relevantCtrl = this.findController(sheetKey);
                                                                if (relevantCtrl) {
                                                                    tmpVal = isAggregateFunc ? relevantCtrl.value.map((item) => item[innerControlKey]) : relevantCtrl.value.map((item) => item[innerControlKey])[change.rowIndex];
                                                                }
                                                            }
                                                            tmpVal = tmpVal && tmpVal.filter((el) => el !== null);
                                                            dataParamsMap[innerCode] = isAggregateFunc ? tmpVal : this.formatVal(tmpVal, dataItem.propertyType);
                                                        }
                                                        else {
                                                            relevantCtrl = this.findController(innerCode);
                                                            let dataItem = this.getDataItem(innerCode);
                                                            if (relevantCtrl && dataItem) {
                                                                let val = relevantCtrl.value;
                                                                dataParamsMap[innerCode] = this.formatVal(val, dataItem.propertyType);
                                                            }
                                                        }
                                                    });
                                                    bizRuleCalculate.dataParamsMap = dataParamsMap;
                                                    let id = ctrl.id;
                                                    // @ts-ignore
                                                    let parentKey = ctrl.parentKey ? ctrl.parentKey : '';
                                                    let dataItem = this.getDataItem(id, parentKey);
                                                    if (dataItem) {
                                                        bizRuleCalculate.schemaCode = dataItem.schemaCode;
                                                        bizRuleCalculate.propertyCode = ctrl.id;
                                                    }
                                                    formApi.getComputeFormulaVal(bizRuleCalculate)
                                                        .then((res) => {
                                                        if (res && res.errcode === 0) {
                                                            // let dataItem = this.getDataItem(ctrl.id as string);
                                                            if (dataItem) {
                                                                switch (dataItem.propertyType) {
                                                                    case DataItemType.ShortText:
                                                                        ctrl.value = res.data || res.data === false ? String(res.data) : '';
                                                                        break;
                                                                    case DataItemType.Number:
                                                                        ctrl.value = res.data ? Number(res.data) : 0;
                                                                        break;
                                                                    default:
                                                                        ctrl.value = res.data;
                                                                        break;
                                                                }
                                                            }
                                                        }
                                                        this.setComputeFormulComplete();
                                                    })
                                                        .catch((err) => {
                                                        console.log("获取计算值失败", err);
                                                        this.setComputeFormulComplete();
                                                    });
                                                }
                                            }, 500);
                                        }
                                        else {
                                            let rowIndex = ctrl.options.rowIndex || 0;
                                            if (rowIndex === change.rowIndex) {
                                                if (Array.isArray(relevantDataItems)) {
                                                    localStorage.setItem('isComputeFormulComplete', 'false');
                                                }
                                                setTimeout(() => {
                                                    let bizRuleCalculate = {};
                                                    bizRuleCalculate.expression = formulaStr;
                                                    let dataParamsMap = {};
                                                    if (Array.isArray(relevantDataItems)) {
                                                        relevantDataItems.forEach((formulaInnerKey) => {
                                                            let innerCode = formulaInnerKey.substring(1, formulaInnerKey.length - 1);
                                                            let relevantCtrl = null;
                                                            const idx = innerCode.indexOf('.');
                                                            if (idx > -1) {
                                                                // 子表条件
                                                                const sheetKey = innerCode.substring(0, idx);
                                                                const innerControlKey = innerCode.substr(idx + 1);
                                                                let dataItem = this.getDataItem(innerControlKey, sheetKey);
                                                                let tmpVal = null;
                                                                if (controlKey === innerControlKey) {
                                                                    tmpVal = change.value[change.rowIndex];
                                                                }
                                                                else {
                                                                    relevantCtrl = this.findController(sheetKey);
                                                                    if (relevantCtrl) {
                                                                        tmpVal = relevantCtrl.value.map((item) => item[innerControlKey])[change.rowIndex];
                                                                    }
                                                                }
                                                                dataParamsMap[innerCode] = this.formatVal(tmpVal, dataItem.propertyType);
                                                            }
                                                            else {
                                                                relevantCtrl = this.findController(innerCode);
                                                                let dataItem = this.getDataItem(innerCode);
                                                                if (relevantCtrl && dataItem) {
                                                                    let val = relevantCtrl.value;
                                                                    dataParamsMap[innerCode] = this.formatVal(val, dataItem.propertyType);
                                                                }
                                                            }
                                                        });
                                                        bizRuleCalculate.dataParamsMap = dataParamsMap;
                                                        let id = ctrl.id;
                                                        // @ts-ignore
                                                        let parentKey = ctrl.parentKey ? ctrl.parentKey : '';
                                                        let dataItem = this.getDataItem(id, parentKey);
                                                        if (dataItem) {
                                                            bizRuleCalculate.schemaCode = dataItem.schemaCode;
                                                            bizRuleCalculate.propertyCode = ctrl.id;
                                                        }
                                                        formApi.getComputeFormulaVal(bizRuleCalculate)
                                                            .then((res) => {
                                                            if (res && res.errcode === 0) {
                                                                if (res.data !== undefined && res.data !== null) {
                                                                    switch (dataItem.propertyType) {
                                                                        case DataItemType.ShortText:
                                                                            ctrl.value = res.data || res.data === false ? String(res.data) : '';
                                                                            break;
                                                                        case DataItemType.Number:
                                                                            ctrl.value = res.data ? Number(res.data) : 0;
                                                                            break;
                                                                        default:
                                                                            ctrl.value = res.data;
                                                                            break;
                                                                    }
                                                                }
                                                            }
                                                            this.setComputeFormulComplete();
                                                        })
                                                            .catch((err) => {
                                                            console.log("获取计算值失败", err);
                                                            this.setComputeFormulComplete();
                                                        });
                                                    }
                                                }, 500);
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                    else {
                        controller = this.findController(dataItemKey);
                        if (controller && controller.valueChange) {
                            const that = this;
                            if (!ctrl.readonly || this.InEdit) {
                                if (controller.value === controller.options.value && controller.value) {
                                    that.ctrlComputeFormula(ctrl, relevantDataItems, formulaStr);
                                }
                            }
                            const optimizationValChange = controller.valueChange.pipe(debounceTime(500));
                            optimizationValChange.subscribe((change) => {
                                if (!ctrl.readonly || this.InEdit) {
                                    that.ctrlComputeFormula(ctrl, relevantDataItems, formulaStr);
                                }
                            });
                        }
                    }
                });
            }
            else {
                // TODAY 函数
                if (formulaStr === "TODAY()") {
                    if (!ctrl.readonly || this.InEdit) {
                        let bizRuleCalculate = {};
                        bizRuleCalculate.expression = formulaStr;
                        bizRuleCalculate.dataParamsMap = null;
                        let id = ctrl.id;
                        // @ts-ignore
                        let parentKey = ctrl.parentKey ? ctrl.parentKey : '';
                        let dataItem = this.getDataItem(id, parentKey);
                        if (dataItem) {
                            bizRuleCalculate.schemaCode = dataItem.schemaCode;
                            bizRuleCalculate.propertyCode = ctrl.id;
                        }
                        localStorage.setItem('isComputeFormulComplete', 'false');
                        formApi.getComputeFormulaVal(bizRuleCalculate)
                            .then((res) => {
                            if (res && res.errcode === 0) {
                                // let dataItem = this.getDataItem(ctrl.id as string);
                                if (dataItem) {
                                    switch (dataItem.propertyType) {
                                        case DataItemType.ShortText:
                                            ctrl.value = res.data || res.data === false ? String(res.data) : '';
                                            break;
                                        case DataItemType.Number:
                                            ctrl.value = res.data ? Number(res.data) : 0;
                                            break;
                                        default:
                                            ctrl.value = res.data;
                                            break;
                                    }
                                }
                            }
                            this.setComputeFormulComplete();
                        })
                            .catch((err) => {
                            console.log("获取计算值失败", err);
                            this.setComputeFormulComplete();
                        });
                    }
                }
            }
        }
        this.unsubscribeValueChange();
        this.valueChangeSubscription = ctrl.propertyChange.subscribe((change) => {
            switch (change.name) {
                case PropertyNames.Value:
                    this.emitControlOnChange(change);
                    if (this.handleValueChange) {
                        if ((!ctrl.readonly || this.InEdit) && !isEqual(change.value, change.oldValue)) {
                            this.handleValueChange(change.value, change);
                        }
                    }
                    break;
                // case PropertyNames.Readonly:
                //   this.control.edit = change.value === false;
                //   break;
            }
        });
    }
    /**
     * 主表计算规则逻辑请求接口
     * @param ctrl
     * @param relevantDataItems
     * @param formulaStr
     */
    ctrlComputeFormula(ctrl, relevantDataItems, formulaStr) {
        if (Array.isArray(relevantDataItems)) {
            localStorage.setItem('isComputeFormulComplete', 'false');
        }
        setTimeout(() => {
            // 组装参数去调用后台接口获取计算值
            let bizRuleCalculate = {};
            bizRuleCalculate.expression = formulaStr;
            let dataParamsMap = {};
            if (Array.isArray(relevantDataItems)) {
                relevantDataItems.forEach((formulaInnerKey) => {
                    let innerCode = formulaInnerKey.substring(1, formulaInnerKey.length - 1);
                    let relevantCtrl = null;
                    const idx = innerCode.indexOf('.');
                    if (idx > -1) {
                        // 子表条件
                        const sheetKey = innerCode.substring(0, idx);
                        const controlKey = innerCode.substr(idx + 1);
                        relevantCtrl = this.findController(sheetKey);
                        if (relevantCtrl) {
                            let data = relevantCtrl.value.map((item) => item[controlKey]) || [];
                            data = data.filter(el => !!el);
                            let rowIndex = ctrl.options.rowIndex || 0;
                            dataParamsMap[innerCode] = data.length ? data[rowIndex] : [];
                        }
                    }
                    else {
                        relevantCtrl = this.findController(innerCode);
                        let dataItem = this.getDataItem(innerCode);
                        if (relevantCtrl && dataItem) {
                            // 根据控件类型传入值
                            let val = relevantCtrl.value;
                            dataParamsMap[innerCode] = this.formatVal(val, dataItem.propertyType);
                        }
                    }
                });
                bizRuleCalculate.dataParamsMap = dataParamsMap;
                let id = ctrl.id;
                // @ts-ignore
                let parentKey = ctrl.parentKey ? ctrl.parentKey : '';
                let dataItem = this.getDataItem(id, parentKey);
                // console.log('parentKey',parentKey);
                // console.log('dataItem',dataItem);
                // console.log('dataItem.code',dataItem.code);
                // console.log('dataItem.schemaCode',dataItem.schemaCode);
                if (dataItem) {
                    bizRuleCalculate.schemaCode = dataItem.schemaCode;
                    bizRuleCalculate.propertyCode = ctrl.id;
                }
                formApi.getComputeFormulaVal(bizRuleCalculate)
                    .then((res) => {
                    if (res && res.errcode === 0) {
                        // let dataItem = this.getDataItem(ctrl.id as string);
                        if (dataItem) {
                            switch (dataItem.propertyType) {
                                case DataItemType.ShortText:
                                    ctrl.value = res.data || res.data === false ? String(res.data) : '';
                                    break;
                                case DataItemType.Number:
                                    ctrl.value = res.data ? Number(res.data) : 0;
                                    break;
                                default:
                                    ctrl.value = res.data;
                                    break;
                            }
                        }
                    }
                    this.setComputeFormulComplete();
                })
                    .catch((err) => {
                    console.log("获取计算值失败", err);
                    this.setComputeFormulComplete();
                });
            }
        }, 500);
    }
    /**
     * 设置缓存：计算规则状态完成
     */
    setComputeFormulComplete() {
        setTimeout(() => {
            localStorage.setItem('isComputeFormulComplete', 'true');
        }, 1100);
    }
    emitControlOnChange(change) {
        const opts = this.controlOpts;
        if (this.ctrl.inSheet) { // 如果在子表内触发了事件 则要标记当前行状态
            const parentKey = this.control.parentKey;
            const key = this.control.key;
            const options = this.ctrl.options;
            if (parentKey) {
                this.changeFormSheetRowStatus(parentKey, key, options);
            }
        }
        if (!opts.onChange) {
            return;
        }
        if (!this.onChangeFn) {
            this.onChangeFn = new Function("value", "oldValue", "form", opts.onChange);
        }
        const proxy = this.getThisProxy();
        this.onChangeFn.call(proxy, change.value, change.oldValue, proxy);
    }
    /**
     * 设置缓存：数据联动状态完成
     */
    setDataLinkageComplete() {
        setTimeout(() => {
            localStorage.setItem('isDataLinkageComplete', 'true');
        }, 3000); //很多个数据联动，并且存在子表数据联动时响应会很慢，导致计算结果还未渲染状态值已经完成，所以延迟调整为3000ms
    }
    emitOnDataLinkage(params) {
        // 传入的参数格式key_dataItemType_fromControlType
        let isOnlyMainCondition = params.extraCond.join('&&').indexOf('.') === -1;
        let isSheetItem = params.fillProperty.src.indexOf('.') > -1;
        let { key: srcKey } = this.formatKey(params.fillProperty.src);
        const ctrl = this.ctrl;
        let controller = null;
        let rowIndex = 0;
        let filterArr = [];
        let mulRelevantKeyArr = [];
        params.filter.forEach((x) => {
            let targetKeyArr = x.key.split('|');
            if (Array.isArray(targetKeyArr) && targetKeyArr.length === 2) {
                if (Number(targetKeyArr[1]) === DataItemType.RelevanceFormEx) {
                    mulRelevantKeyArr.push(x.key);
                }
                let filterVal = this.formatVal(x.val, Number(targetKeyArr[1]), true);
                filterArr.push({
                    propertyCode: targetKeyArr[0],
                    propertyType: Number(targetKeyArr[1]),
                    propertyValue: filterVal,
                    //@ts-ignore
                    op: this.formatOpByDataItemType(Number(targetKeyArr[1]), filterVal)
                });
            }
            else {
                let { key: xKey, dataItemType: xDataItemType, formControlType: xFormControlType } = this.formatKey(x.key);
                if (Number(xFormControlType) === 81) {
                    mulRelevantKeyArr.push(xKey);
                }
                let filterVal = this.formatVal(x.val, Number(xFormControlType), true);
                filterArr.push({
                    propertyCode: xKey,
                    propertyType: Number(xDataItemType),
                    propertyValue: filterVal,
                    //@ts-ignore
                    op: this.formatOpByFormControlType(Number(xFormControlType), filterVal)
                });
            }
        });
        let targetKey = params.fillProperty["target"];
        let xKey = null;
        let targetKeyArr = targetKey.split('|');
        let targetType = 0;
        let targetControlType = -1;
        if (Array.isArray(targetKeyArr) && targetKeyArr.length === 2) {
            xKey = targetKeyArr[0];
            targetType = targetKeyArr[1];
        }
        else {
            let { key, dataItemType, formControlType } = this.formatKey(targetKey);
            xKey = key;
            targetType = Number(dataItemType);
            targetControlType = Number(formControlType);
        }
        let mixParams = {
            filters: filterArr,
            mobile: false,
            page: 0,
            size: 20,
            queryCode: params.targetModel,
            schemaCode: params.targetModel,
            // @ts-ignore
            options: {
                // @ts-ignore
                customDisplayColumns: [xKey].concat(mulRelevantKeyArr),
                // @ts-ignore
                queryDisplayType: 1
            },
            // @ts-ignore
            customizedQuery: true
        };
        if (ctrl.options.inSheet) {
            if (isOnlyMainCondition && isSheetItem) {
                // 只有主表条件并且联动项是子表项, 需求要求将满足条件的数据项加到子表中
                if (rowIndex === 0) {
                    listApi.getQueryList(mixParams).then(res => {
                        let sheetKey = srcKey.substring(0, srcKey.indexOf('.'));
                        let itemKey = srcKey.substring(srcKey.indexOf('.') + 1);
                        let sheet = this.findController(sheetKey);
                        let sheetControl = this.getFormControls([sheetKey])[0];
                        if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                            let rows = [];
                            res.data.content.forEach((item) => {
                                let vals = Object.create(null);
                                vals[itemKey] = '';
                                rows.push(vals);
                            });
                            sheet.value = rows;
                            setTimeout(() => {
                                let rows = [];
                                res.data.content.forEach((item, index) => {
                                    let rowData = Object.create(null);
                                    let val = item.data[xKey];
                                    rowData[itemKey] = this.formatValByType(val, targetType, targetControlType);
                                    rows.push(rowData);
                                });
                                sheet.value = rows;
                            }, 10);
                        }
                        else {
                            sheet.value = [];
                        }
                        this.setDataLinkageComplete();
                    });
                }
            }
            else {
                const idx = srcKey.indexOf('.');
                rowIndex = ctrl.options.rowIndex || 0;
                const sheetKey = srcKey.substring(0, idx);
                const controlKey = srcKey.substr(idx + 1);
                const sheetCtrl = this.findController(sheetKey);
                if (sheetCtrl) {
                    const row = sheetCtrl.rows[rowIndex];
                    controller = row.findChild(controlKey);
                }
                listApi.getQueryList(mixParams).then(res => {
                    if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                        let val = res.data.content[0]["data"][xKey];
                        //根据目标控件类型格式化值
                        controller.value = this.formatValByType(val, targetType, targetControlType);
                    }
                    else {
                        switch (Number(targetType)) {
                            case DataItemType.Date:
                            case DataItemType.Attachment:
                            case DataItemType.StaffSingle:
                            case DataItemType.StaffMulti:
                            case DataItemType.DeptSingle:
                            case DataItemType.DeptMulti:
                            case DataItemType.StaffDeptMix:
                            case DataItemType.Sheet:
                            case DataItemType.RelevanceForm:
                            case DataItemType.RelevanceFormEx:
                            case DataItemType.Sheet:
                            case DataItemType.Address:
                            case DataItemType.Number:
                            case DataItemType.Checkbox:
                            case DataItemType.Logic:
                            case DataItemType.Time:
                                controller.value = null;
                                break;
                            case DataItemType.DropdownMulti: // 下拉多选数据格式是数组，清空操作
                                controller.value = [];
                                break;
                            default:
                                controller.value = "";
                                break;
                        }
                    }
                    this.setDataLinkageComplete();
                });
            }
        }
        else {
            controller = this.findController(srcKey);
            listApi.getQueryList(mixParams).then(res => {
                if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                    let val = res.data.content[0]["data"][xKey];
                    //根据目标控件类型格式化值
                    controller.value = this.formatValByType(val, targetType, targetControlType);
                }
                else {
                    switch (Number(targetType)) {
                        case DataItemType.Date:
                        case DataItemType.Attachment:
                        case DataItemType.StaffSingle:
                        case DataItemType.StaffMulti:
                        case DataItemType.DeptSingle:
                        case DataItemType.DeptMulti:
                        case DataItemType.StaffDeptMix:
                        case DataItemType.Sheet:
                        case DataItemType.RelevanceForm:
                        case DataItemType.RelevanceFormEx:
                        case DataItemType.Sheet:
                        case DataItemType.Address:
                        case DataItemType.Number:
                        case DataItemType.Checkbox:
                        case DataItemType.Logic:
                        case DataItemType.Time:
                            controller.value = null;
                            break;
                        case DataItemType.DropdownMulti: // 下拉多选数据格式是数组，清空操作
                            controller.value = [];
                            break;
                        default:
                            controller.value = "";
                            break;
                    }
                }
                this.setDataLinkageComplete();
            });
        }
    }
    // 更新子表某一行的状态
    /**
     * 初始状态，未做任何改变
     * Unchanged
     */
    /**
     * 已新增，保存所有离线的新增
     * Added
     */
    /**
     * 已删除，对应数据库中的需要删除的记录
     * Deleted
     */
    /**
     * 已修改，对应数据库中需要修改的记录
     * Modified
     */
    changeFormSheetRowStatus(parentKey, key, options) {
        // 通过当前控件「parentKey」找到子表
        const sheetCtrl = this.findController(parentKey);
        const value = sheetCtrl.value;
        value.forEach((item, index) => {
            if (index === options.rowIndex) {
                if (!item.id) {
                    item.rowStatus = 'Added';
                }
                else {
                    item.rowStatus = 'Modified';
                }
            }
        });
        sheetCtrl.value = value;
    }
    // 传入的参数格式key_dataItemType_fromControlType
    formatKey(keyStr) {
        const isOldStyle = /\w+\_(\d+|null)\_(\d+|null)/.test(keyStr);
        if (isOldStyle) {
            let _lastIndex = keyStr.lastIndexOf('_');
            let _last2rdIndex = keyStr.lastIndexOf('_', _lastIndex - 1);
            let key = keyStr.substring(0, _last2rdIndex);
            let dataItemType = keyStr.substring(_last2rdIndex + 1, _lastIndex);
            let formControlType = keyStr.substr(_lastIndex + 1);
            return {
                key,
                dataItemType,
                formControlType
            };
        }
        else {
            return {
                key: keyStr,
                dataItemType: -1,
                formControlType: -1
            };
        }
    }
    formatValByType(val, targetType, targetControlType) {
        let retVal = val;
        if (Number(targetControlType) === -1) {
            switch (Number(targetType)) {
                case DataItemType.ShortText:
                case DataItemType.Radio:
                case DataItemType.Dropdown:
                    if (typeof val === "string" && val.length <= 200) {
                        retVal = val;
                    }
                    else if (typeof val !== "object") {
                        retVal = val.toString();
                    }
                    else if (typeof val === "object") {
                        retVal = JSON.stringify(val) !== 'null' ? JSON.stringify(val) : '';
                    }
                    break;
                case DataItemType.LongText:
                    if (typeof val === "string") {
                        retVal = val;
                    }
                    break;
                case DataItemType.Number:
                    if (val === "") {
                        retVal = null;
                    }
                    retVal = Number(val);
                    break;
                case DataItemType.Logic:
                    retVal = Boolean(val);
                    break;
                case DataItemType.Date:
                    if (val instanceof Date) {
                        retVal = val;
                    }
                    else if (typeof val === "string" && val) {
                        try {
                            let str = val
                                .replace(/-/g, "/") // iOS兼容
                                .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                            let date = new Date(str);
                            if (date.getFullYear() > 0) {
                                retVal = date;
                            }
                        }
                        catch (_a) { }
                    }
                    break;
                case DataItemType.Time:
                    if (typeof val === "string" && val) {
                        retVal = moment(val, "HH:mm:ss");
                    }
                    break;
                case DataItemType.Checkbox:
                case DataItemType.DropdownMulti:
                    if (typeof val === "string") {
                        retVal = val.split(";").filter((x) => !!x);
                    }
                    else if (typeof val === "object") {
                        retVal = [val];
                    }
                    else if (Array.isArray(val) &&
                        val.some((x) => typeof x === "string")) {
                        retVal = val;
                    }
                    break;
                case DataItemType.Address:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_b) { }
                    }
                    if (typeof val === "object") {
                        retVal = val;
                    }
                    break;
                case DataItemType.Attachment:
                case DataItemType.StaffSingle:
                case DataItemType.StaffMulti:
                case DataItemType.DeptSingle:
                case DataItemType.DeptMulti:
                case DataItemType.StaffDeptMix:
                case DataItemType.Sheet:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_c) { }
                    }
                    if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
                        retVal = val;
                    }
                    break;
                case DataItemType.ApprovalOpinion:
                    if (typeof val === "string") {
                        retVal = {
                            content: val,
                        };
                    }
                    else if (typeof val === "object" &&
                        typeof val.content === "string") {
                        retVal = val;
                    }
                    break;
                case DataItemType.RelevanceForm:
                case DataItemType.RelevanceFormEx:
                case DataItemType.Address:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_d) { }
                    }
                    if (typeof val === "object") {
                        retVal = val;
                    }
                    break;
            }
        }
        else {
            switch (Number(targetControlType)) {
                case FormControlType.Text:
                case FormControlType.Radio:
                case FormControlType.Dropdown:
                    if (typeof val === "string" && val.length <= 200) {
                        retVal = val;
                    }
                    else if (typeof val !== "object") {
                        retVal = val.toString();
                    }
                    else if (typeof val === "object" && val !== null) {
                        retVal = JSON.stringify(val);
                    }
                    break;
                case FormControlType.SequenceNo:
                case FormControlType.Textarea:
                case FormControlType.Description:
                case FormControlType.Title:
                    if (typeof val === "string") {
                        retVal = val;
                    }
                    break;
                case FormControlType.Number:
                    if (val === "") {
                        retVal = null;
                    }
                    retVal = Number(val);
                    break;
                case FormControlType.Logic:
                    retVal = Boolean(val);
                    break;
                case FormControlType.Date:
                case FormControlType.CreatedTime:
                case FormControlType.ModifiedTime:
                    if (val instanceof Date) {
                        retVal = val;
                    }
                    else if (typeof val === "string" && val) {
                        try {
                            let str = val
                                .replace(/-/g, "/") // iOS兼容
                                .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                            let date = new Date(str);
                            if (date.getFullYear() > 0) {
                                retVal = date;
                            }
                        }
                        catch (_e) { }
                    }
                    break;
                case FormControlType.Time:
                    if (typeof val === "string" && val) {
                        retVal = moment(val, "HH:mm:ss");
                    }
                    break;
                case FormControlType.Checkbox:
                    if (typeof val === "string") {
                        retVal = val.split(";").filter((x) => !!x);
                    }
                    else if (typeof val === "object") {
                        retVal = [val];
                    }
                    else if (Array.isArray(val) &&
                        val.some((x) => typeof x === "string")) {
                        retVal = val;
                    }
                    break;
                case FormControlType.Location:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_f) { }
                    }
                    if (typeof val === "object") {
                        retVal = val;
                    }
                    break;
                case FormControlType.Image:
                case FormControlType.Attachment:
                case FormControlType.Signature:
                case FormControlType.StaffSelector:
                case FormControlType.StaffMultiSelector:
                case FormControlType.DepartmentSelector:
                case FormControlType.DepartmentMultiSelector:
                case FormControlType.CreateBy:
                case FormControlType.ModifyBy:
                case FormControlType.OwnerId:
                case FormControlType.CreateByParentId:
                case FormControlType.Sheet:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_g) { }
                    }
                    if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
                        retVal = val;
                    }
                    break;
                case FormControlType.ApprovalOpinion:
                    if (typeof val === "string") {
                        retVal = {
                            content: val,
                        };
                    }
                    else if (typeof val === "object" &&
                        typeof val.content === "string") {
                        retVal = val;
                    }
                    break;
                case FormControlType.DateRange:
                case FormControlType.NumberRange:
                case FormControlType.TimeRange:
                    if (Array.isArray(val)) {
                        retVal = val;
                    }
                    break;
                case FormControlType.ReverseRelevance:
                case FormControlType.RelevanceForm:
                case FormControlType.RelevanceFormEx:
                case FormControlType.Address:
                    if (typeof val === "string") {
                        try {
                            val = JSON.parse(val);
                        }
                        catch (_h) { }
                    }
                    if (typeof val === "object") {
                        retVal = val;
                    }
                    break;
            }
        }
        return retVal;
    }
    // 根据表单控件类型去格式化值
    formatVal(val, type, isDataLink = false) {
        let propertyValue = null;
        if (val) {
            switch (type) {
                case DataItemType.Number:
                    propertyValue = Number(val);
                    break;
                case DataItemType.ShortText:
                case DataItemType.LongText:
                case DataItemType.Radio:
                case DataItemType.Dropdown:
                    propertyValue = String(val);
                    break;
                case DataItemType.Logic:
                    propertyValue = Boolean(val);
                    break;
                case DataItemType.Date: // 日期
                    propertyValue = val instanceof Date ? dateFormat.formatter(val, "YYYY-MM-DD HH:mm:ss") : val;
                    break;
                case DataItemType.Checkbox: // 复选框
                case DataItemType.DropdownMulti: // 下拉多选框
                    propertyValue = val.join(';');
                    break;
                case DataItemType.Address: // 地址
                    if (val && Object.keys(val).length > 0) {
                        propertyValue = JSON.stringify(val);
                    }
                    else {
                        propertyValue = null;
                    }
                    break;
                case DataItemType.StaffSingle: // 人员单复选
                case DataItemType.StaffMulti:
                case DataItemType.DeptSingle:
                case DataItemType.DeptMulti:
                case DataItemType.StaffDeptMix:
                    if (isDataLink) {
                        let tmpVal = val.map((m) => {
                            return {
                                id: m.id,
                                unitType: m.unitType,
                                name: m.name
                            };
                        });
                        propertyValue = JSON.stringify(tmpVal);
                    }
                    else {
                        propertyValue = val.map((x) => x.name).join(';');
                    }
                    break;
                case DataItemType.RelevanceForm:
                    propertyValue = val.id;
                    break;
                case DataItemType.RelevanceFormEx:
                    propertyValue = val.map((x) => x.id).join(';');
                    break;
                default:
                    propertyValue = String(val);
                    break;
            }
        }
        else {
            switch (type) {
                case DataItemType.Logic:
                    return Boolean(val);
                case DataItemType.Number:
                    //参数为空字符串时转换为0传递到后端计算
                    return Number(val);
                default:
                    return "";
            }
        }
        return propertyValue;
    }
    formatOpByDataItemType(type, val) {
        switch (type) {
            case DataItemType.Checkbox:
            case DataItemType.Address:
            case DataItemType.RelevanceForm:
            case DataItemType.RelevanceFormEx:
                return "Like";
            case DataItemType.StaffSingle:
            case DataItemType.StaffMulti:
            case DataItemType.DeptSingle:
            case DataItemType.DeptMulti:
            case DataItemType.StaffDeptMix:
                // 选人选组织控件 当没有值时 需要传Eq,有值需要传Like
                if (!val) {
                    return "Eq";
                }
                else {
                    return "Like";
                }
            default:
                return "Eq";
        }
    }
    formatOpByFormControlType(type, val) {
        switch (type) {
            case 6:
            case 14:
            case 80:
            case 81:
                return "Like";
            case 50:
            case 51:
            case 60:
            case 61:
                // 选人选组织控件 当没有值时 需要传Eq,有值需要传Like
                if (!val) {
                    return "Eq";
                }
                else {
                    return "Like";
                }
            default:
                return "Eq";
        }
    }
    validate() {
        this.ctrl.validate(false);
    }
    // countLengthOf(s: string) {
    //     if (!s) {
    //         return 0;
    //     }
    //     const reg = /[\u4e00-\u9fa5]+/;
    //     let result: RegExpExecArray | null;
    //     let len = 0;
    //     while (result = reg.exec(s), result !== null) {
    //         len += result[0].length * 2;
    //         s = s.replace(reg, '');
    //     }
    //     len += s.length;
    //     return len;
    // }
    /**
     *
     * @param formControls 所有的control
     * @param exp
     */
    parseConditions(formControls, exp) {
        let segs = [];
        const results = [];
        if (exp.indexOf("||") > -1) {
            segs = exp.split(" || ");
        }
        else {
            if (exp.indexOf("&&") > -1) {
                segs = exp.split(" && ");
            }
            else {
                segs = [exp];
            }
        }
        for (const seg of segs) {
            const fields = seg.split(" ");
            const code = fields[2].substring(1, fields[2].length - 1);
            let ctrl;
            let control;
            const idx = code.indexOf(".");
            if (idx > -1) {
                const parentCode = code.substring(0, idx);
                const childCode = code.substring(idx + 1);
                const sheet = formControls.find((c) => c.key === parentCode);
                if (sheet) {
                    control = sheet.columns.find((c) => c.key === childCode);
                }
                const sheetCtrl = this.findController(parentCode);
                if (sheetCtrl &&
                    this.ctrl.options &&
                    typeof this.ctrl.options.rowIndex === "number") {
                    const row = sheetCtrl.rows[this.ctrl.options.rowIndex];
                    ctrl = row.findChild(childCode);
                }
            }
            else {
                ctrl = this.findController(code);
                control = formControls.find((c) => c.key === code);
            }
            if (!ctrl || !control) {
                continue;
            }
            const type = ControlHelper.mapToDataItemType(control.type);
            let operator = OperatorService.findByLabel(type, fields[1]);
            if (!operator) {
                continue;
            }
            // let val: any;
            // if (
            //   !(
            //     operator.value === DateItemOperatorType.IsNull ||
            //     operator.value === DateItemOperatorType.IsNotNull
            //   )
            // ) {
            //   val = fields[2];
            //   switch (type) {
            //     case DataItemType.Number:
            //       val = Number(val);
            //       break;
            //     case DataItemType.Logic:
            //       val = val === "true" ? 1 : 0;
            //       break;
            //     case DataItemType.Date:
            //     case DataItemType.ShortText:
            //     case DataItemType.LongText:
            //       val = val.substring(1, val.length - 1);
            //       break;
            //     case DataItemType.StaffSingle:
            //       if (val) {
            //         try {
            //           val = JSON.parse(val);
            //         } catch (e) {
            //           console.log("initModel", e);
            //         }
            //       }
            //       break;
            //   }
            // }
            results.push({
                code: fields[0],
                control,
                controller: ctrl,
                propertyType: type,
                operatorType: operator.value,
            });
        }
        return results;
    }
    countLengthOf(s) {
        if (!s) {
            return 0;
        }
        return s.length;
    }
    subscribePropertyChange(fn) {
        const ctrl = this.findController(this.id);
        if (!ctrl) {
            return;
        }
        if (this.propChangeSubscription) {
            this.propChangeSubscription.add(ctrl.propertyChange.subscribe(fn));
        }
        else {
            this.propChangeSubscription = ctrl.propertyChange.subscribe(fn);
        }
    }
    unsubscribeValueChange() {
        if (this.valueChangeSubscription) {
            this.valueChangeSubscription.unsubscribe();
        }
    }
    unsubscribe() {
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
        if (this.propChangeSubscription) {
            this.propChangeSubscription.unsubscribe();
        }
    }
    /**
     * 取消control中注册的订阅事件
     * @param control
     */
    unRefSubscription(control) {
        if (control && control.refSubscription && control.refSubscription.length) {
            control.refSubscription.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
        ;
    }
    /**
     * 清理control中订阅事件延时器
     * @param control
     */
    unRefSubscriptionTimer(control) {
        if (control && control.refSubscriptionTimer && control.refSubscriptionTimer.length) {
            control.refSubscriptionTimer.forEach((timer) => {
                clearTimeout(timer);
            });
        }
        ;
    }
    destroyed() {
        this.unsubscribe();
        this.unsubscribeValueChange();
        this.unRefSubscription(this.control);
        this.unRefSubscriptionTimer(this.control);
    }
}
tslib_1.__decorate([
    Prop()
], BaseControl.prototype, "control", void 0);
tslib_1.__decorate([
    Watch("ctrl.items")
], BaseControl.prototype, "onCtrlItemsChange", null);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "findController", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getController", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getFormControls", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getScrollEl", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "valChange", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getDataItem", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getRelativeDataList", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getSourceType", void 0);
tslib_1.__decorate([
    Watch("control", {
        immediate: true,
    })
], BaseControl.prototype, "onControlChange", null);
